/** Navigation from outside React components (toast actions, helpers). App registers the router's navigate. */
let navigator: ((path: string) => void) | null = null;
export function setNavigator(fn: (path: string) => void) {
  navigator = fn;
}
export function navigateTo(path: string) {
  if (navigator) navigator(path);
  else location.assign(path);
}
